import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";

// Main component for Device Marketplace
export default function DeviceMarketplace() {
  // Overview Data: Describes the marketplace's primary offerings
  const data1 = [
    "Devices: AgriFood Tech devices such as soil moisture sensors, weather stations, precision agriculture drones, smart irrigation controllers, greenhouse automation systems, RFID tags, temperature and humidity sensors, livestock health monitoring systems, and smart collars or ear tags, are designed to collect and transmit real-time data. These devices communicate through both wired and wireless technologies, sending signals to connected networks for data processing and analysis, ultimately improving farm management, sustainability, and productivity.",
    "BaseStations, Connectivity, and Accessories: AgriFood Tech gateways and base stations should be equipped with edge computing capabilities, enabling on-site data processing to minimize latency and ensure real-time decision-making. These devices must also feature data backhaul technologies such as Ethernet or cellular to transfer collected data efficiently to centralized systems or cloud platforms for further analysis. For long-range communication, protocols like LoRa, WiFi, and Cellular are essential, allowing data to be transmitted across large farms or remote areas. These technologies enable seamless integration with sensors, drones, and other IoT devices, providing the necessary infrastructure to gather and relay data for AI/ML model processing at various data centers or cloud-based platforms. This setup ensures that AI/ML models can process the collected data to deliver actionable insights, automate processes, and improve decision-making across agriculture and food processing operations."
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="solution-marketplace-bg"
        bannerTitle={["DeviceMarketplace"]}
        bannerbodycopy="Devices | BaseStations | Connectivities | Accessories"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="DeviceMarketplace" />

      {/* Overview Features Section */}
      <Container>
        <OverviewFeatures data1={data1} />
      </Container>
    </>
  );
}
